/**
 * * Check those links for more information about this code:
 * * - https://github.com/apollographql/apollo-client/issues/8858#issuecomment-1190040521
 * * - https://github.com/apollographql/apollo-client/issues/4150#issuecomment-500127694
 */
import { ApolloLink, Observable } from "@apollo/client";

const connections: { [key: string]: unknown } = {};

const allowedOperations = new Set(["GetInAppPurchases"]);
export const cancelRequestLink = new ApolloLink(
  (operation, forward) =>
    new Observable((observer) => {
      const context = operation.getContext();
      const { operationName } = operation;

      const connectionHandle = forward(operation).subscribe({
        next: (...arg) => observer.next(...arg),
        error: (...arg) => {
          delete connections[operationName];
          observer.error(...arg);
        },
        complete: (...arg) => {
          delete connections[operationName];
          observer.complete(...arg);
        },
      });

      if (!context.preventCancelations && !allowedOperations.has(operationName)) {
        if (connections[operationName]) {
          console.log("Aborted operation: ", connections[operationName]);
          connections[operationName].error(new Error("Request aborted"));
          delete connections[operationName];
        }

        connections[operationName] = observer;
      }
      return connectionHandle;
    })
);
